import { IState } from '../store';
import { pathOr } from 'ramda';

export const getNewbuildingId = (state: IState) => {
  return pathOr(null, ['offerData', 'newObject', 'id'], state);
};
